import React, { FC, useContext } from 'react';
import { CashinButton } from './CashinButton';
import TurboLiveContext from '../../context/TurboLiveContext';
import CashinPositionContext from '../../../../common/CashinPositionContext';

export const CashinButtonLive: FC<{ ticketId: string }> = ({ ticketId }) => {
    const { openCashinDialog, openAutoCashinDialog } = useContext(TurboLiveContext);
    const { cashinPosition } = useContext(CashinPositionContext);

    const handleClick = ref => e => {
        openCashinDialog(ticketId, ref, cashinPosition);
        e.stopPropagation();
    };

    const handleClickAutoCashin = ref => e => {
        openAutoCashinDialog(ticketId, ref, cashinPosition);
        e.stopPropagation();
    };

    return <CashinButton ticketId={ticketId} handleClick={handleClick} handleClickAutoCashin={handleClickAutoCashin} />;
};
